import { render } from "./StakeEconomy.vue?vue&type=template&id=06820162&scoped=true"
import script from "./StakeEconomy.vue?vue&type=script&lang=js"
export * from "./StakeEconomy.vue?vue&type=script&lang=js"

import "./StakeEconomy.vue?vue&type=style&index=0&id=06820162&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06820162"],['__file',"resources/js/components/StakeEconomy.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06820162"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06820162', __exports__)) {
    api.reload('06820162', __exports__)
  }
  
  module.hot.accept("./StakeEconomy.vue?vue&type=template&id=06820162&scoped=true", () => {
    api.rerender('06820162', render)
  })

}


export default __exports__